if (document.getElementById('temporary-registration-id')) {
  const temporaryRegistrationId = document.getElementById(
    'temporary-registration-id'
  ).dataset.temporaryRegistrationId;
  const eventId = document.getElementById('event-id').dataset.eventId;
  const eventPrice = document.getElementById('event-price-id').dataset
    .eventPrice;
  const registeredUsersBlock = document.getElementById('registeredUsersBlock');
  const summaryRegisterDiv = document.getElementById('summary-register');
  let masterEventAdditionals = '';

  function executorEventsSummary() {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(async function (mutation) {
        if (mutation.target.classList.contains('is-open')) {
          // naplnění daty z API
          getEventAdditionals(eventId).then(function (eventAdditionals) {
            masterEventAdditionals = eventAdditionals;
            getEventParticipants(
              temporaryRegistrationId,
              registeredUsersBlock,
              eventAdditionals
            );
          });
        }
      });
    });

    observer.observe(document.querySelector('#modal-register'), {
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  function getEventAdditionals(eventId) {
    return new Promise((resolve) => {
      $.ajax({
        type: 'POST',
        url: '/api/executor/get-additionals',
        data: {
          eventId: eventId,
        },
        success: function (data) {
          resolve(data);
        },
      });
    });
  }

  function getEventParticipants(
    temporaryRegistrationId,
    registeredUsersBlock,
    eventAdditionals
  ) {
    $.ajax({
      type: 'POST',
      url: '/api/executor/get-participants',
      data: {
        temporaryRegistrationId: temporaryRegistrationId,
      },
      success: function (data) {
        registeredUsersBlock.innerHTML = '';
        data.forEach(function (participant, key) {
          registeredUsersBlock.innerHTML =
            registeredUsersBlock.innerHTML +
            renderParticipant(key, participant, eventAdditionals);
        });
        registeredUsersBlock.innerHTML =
          registeredUsersBlock.innerHTML +
          '<div class="form__block form__block--add">' +
          '    <button class="btn btn--form-classic btn--lg btn--full" id="add-event-participant">Přidat účastníka +</button>' +
          '</div>';
        watchAdditionalCheckboxes();
        watchRemoveButtons();
        watchCreateButton();
        calculatePrice();
        watchUpdateCreatedUser();
      },
    });
  }

  function renderParticipant(key, participant, eventAdditionals) {
    let titleBeforeName = '';
    if (participant.hasOwnProperty('title_before_name')) {
      titleBeforeName = participant.title_before_name;
    }

    let titleAfterName = '';
    if (participant.hasOwnProperty('title_after_name')) {
      titleAfterName = participant.title_after_name;
    }

    let additionalsDiv = renderAdditionalsDiv(eventAdditionals, participant);
    let allowModification = 'readonly';
    let createdEmailClass = '';
    if (participant.email.startsWith('OUT')) {
      allowModification = '';
      createdEmailClass = 'created-email';
    }

    return (
      '<div class="form__block">' +
      '                        <div class="form__action">' +
      '                            <div class="data-item">' +
      '                <span class="icon icon--icon-people">' +
      '                  <svg class="icon__svg"><use xlink:href="#icon-people"></use></svg>' +
      '                </span>' +
      '                                <p>Účastník ' +
      (key + 1) +
      '</p>' +
      '                            </div>' +
      '                            <div class="data-action">' +
      '                                <button class="btn btn--icon">' +
      '                  <span class="icon icon--icon-trash trash-remove-user event-participant" data-employee-id="' +
      participant.email +
      '">' +
      '                    <svg class="icon__svg"><use xlink:href="#icon-trash"></use></svg>' +
      '                  </span>' +
      '                                </button>' +
      '                            </div>' +
      '                        </div>' +
      '                        <div class="form__row form__row--degree-before-after">' +
      '                            <div class="form__item">' +
      '                                <label for="title-before-' +
      (key + 1) +
      '">Titul před</label>' +
      '                                <input type="text" data-input-type="title-before-name" class="' +
      participant.email +
      '" id="title-before-' +
      (key + 1) +
      '" value="' +
      titleBeforeName +
      '" ' +
      allowModification +
      '>' +
      '                            </div>' +
      '                            <div class="form__item">' +
      '                                <label for="name-' +
      (key + 1) +
      '">Jméno a příjmení</label>' +
      '                                <input type="text" data-input-type="full-name" class="' +
      participant.email +
      '" id="name-' +
      (key + 1) +
      '" placeholder="Jan Novák" value="' +
      participant.first_name +
      ' ' +
      participant.last_name +
      '" ' +
      allowModification +
      '>' +
      '                            </div>' +
      '                            <div class="form__item">' +
      '                                <label for="title-after-' +
      (key + 1) +
      '">Titul za</label>' +
      '                                <input type="text" data-input-type="title-after-name" class="' +
      participant.email +
      '" id="title-after-' +
      (key + 1) +
      '" placeholder="MBA." value="' +
      titleAfterName +
      ' " ' +
      allowModification +
      '>' +
      '                            </div>' +
      '                        </div>' +
      '                        <div class="form__row">' +
      '                            <div class="form-item">' +
      '                                <label for="email-' +
      (key + 1) +
      '">Email</label>' +
      '                                <input type="text" data-input-type="email" id="email-' +
      (key + 1) +
      '" data-employee-id="' +
      participant.email +
      '" class="' +
      createdEmailClass +
      ' ' +
      participant.email +
      '" value="' +
      participant.email +
      '" ' +
      allowModification +
      '>' +
      '                            </div>' +
      '                        </div>' +
      additionalsDiv +
      '                    </div>'
    );
  }

  function renderAdditionalsDiv(eventAdditionals, participant) {
    let resultDiv = '<div class="form__row form__row--complementary">';
    eventAdditionals.forEach(function (additional) {
      // check if participant already has additionals in his registration
      let alreadyChecked = false;
      participant.additionals.forEach(function (participantAdditional) {
        if (participantAdditional.id === additional.id) {
          alreadyChecked = true;
        }
      });
      let checkedDiv = '';
      if (alreadyChecked === true) {
        checkedDiv = 'checked';
      }
      let checkboxId = participant.email + '-' + additional.id;
      resultDiv =
        resultDiv +
        '                            <div class="form-checkbox form-checkbox--lg">' +
        '                                <input type="checkbox" class="additional-checkbox" id="' +
        checkboxId +
        '" data-event-id="' +
        additional.event.id +
        '" data-employee-Id="' +
        participant.email +
        '" data-additional-id="' +
        additional.id +
        '" data-additional-price=' +
        additional.price +
        '" data-additional-name="' +
        additional.text +
        '" ' +
        checkedDiv +
        '>' +
        '                                <span class="form-checkbox__box"></span>' +
        '                                <label class="form-label" for="' +
        checkboxId +
        '">' +
        additional.text +
        ' <span class="color-gray">(' +
        additional.price +
        ' Kč)</span></label>' +
        '                            </div>';
    });

    resultDiv = resultDiv + '</div>';

    return resultDiv;
  }

  function watchAdditionalCheckboxes() {
    let additionalCheckboxes = document.getElementsByClassName(
      'additional-checkbox'
    );
    additionalCheckboxes.forEach(function (checkbox) {
      checkbox.addEventListener('change', (event) => {
        let checkbox = event.currentTarget;
        if (checkbox.checked) {
          addAdditionalToUser(
            checkbox.dataset.eventId,
            checkbox.dataset.employeeId,
            checkbox.dataset.additionalId
          );
          calculatePrice();
        } else {
          removeAdditionalFromUser(
            checkbox.dataset.eventId,
            checkbox.dataset.employeeId,
            checkbox.dataset.additionalId
          );
          calculatePrice();
        }
      });
    });
  }

  function addAdditionalToUser(eventId, employeeId, additionalId) {
    $.ajax({
      type: 'POST',
      url: '/api/executor/add-event-additional',
      data: {
        eventId: eventId,
        employeeId: employeeId,
        additionalId: additionalId,
        temporaryRegistrationId: temporaryRegistrationId,
      },
      success: function (data) {},
    });
  }

  function removeAdditionalFromUser(eventId, employeeId, additionalId) {
    $.ajax({
      type: 'POST',
      url: '/api/executor/remove-event-additional',
      data: {
        eventId: eventId,
        employeeId: employeeId,
        additionalId: additionalId,
        temporaryRegistrationId: temporaryRegistrationId,
      },
      success: function (data) {},
    });
  }

  function watchRemoveButtons() {
    let removeButtons = document.getElementsByClassName('trash-remove-user');
    removeButtons.forEach(function (removeButton) {
      removeButton.addEventListener('click', (event) => {
        removeParticipant(event.currentTarget.dataset.employeeId);
      });
    });
  }

  function removeParticipant(employeeId) {
    $.ajax({
      type: 'POST',
      url: '/api/executor/remove-participant',
      data: {
        participantId: employeeId,
        temporaryRegistrationId: temporaryRegistrationId,
      },
      success: function () {
        getEventParticipants(
          temporaryRegistrationId,
          registeredUsersBlock,
          masterEventAdditionals
        );
      },
    });
  }

  function watchCreateButton() {
    let addParticipantButton = document.getElementById('add-event-participant');
    addParticipantButton.addEventListener('click', (event) => {
      $.ajax({
        type: 'POST',
        url: '/api/executor/create-outside-participant',
        data: {
          temporaryRegistrationId: temporaryRegistrationId,
        },
        success: function () {
          getEventParticipants(
            temporaryRegistrationId,
            registeredUsersBlock,
            masterEventAdditionals
          );
        },
      });
    });
  }

  function calculatePrice() {
    const totalWithoutVatDiv = document.getElementById('total-without-vat');
    const vatDiv = document.getElementById('total-vat');
    const dphPercent = document.getElementById('event-dph-id').dataset.eventDphPercent;
    const totalWithVatDiv = document.getElementById('total-with-vat');
    let participants = document.getElementsByClassName('event-participant');
    let participantsCount = participants.length;
    let participantPrice = participantsCount * eventPrice;

    summaryRegisterDiv.innerHTML = '';
    summaryRegisterDiv.innerHTML =
      '<div class="summary__desc">Účasníků</div>' +
      '<div>' +
      participantsCount +
      '</div>' +
      '<div><strong>' +
      formatNumber(participantPrice) +
      ' Kč</strong></div>';

    let additionalCheckboxes = document.getElementsByClassName(
      'additional-checkbox'
    );
    let resolvedCheckboxes = [];

    additionalCheckboxes.forEach(function (checkbox) {
      if (checkbox.checked) {
        let index = resolvedCheckboxes.findIndex(
          (element) => element.name === checkbox.dataset.additionalName
        );
        if (index < 0) {
          resolvedCheckboxes.push({
            name: checkbox.dataset.additionalName,
            count: 1,
            price: parseInt(checkbox.dataset.additionalPrice),
          });
        } else {
          resolvedCheckboxes[index] = {
            name: checkbox.dataset.additionalName,
            count: resolvedCheckboxes[index].count + 1,
            price:
              parseInt(resolvedCheckboxes[index].price) +
              parseInt(checkbox.dataset.additionalPrice),
          };
        }
      }
    });

    let totalCheckboxPrice = 0;
    resolvedCheckboxes.forEach(function (resolvedCheckbox) {
      totalCheckboxPrice += resolvedCheckbox.price;
      summaryRegisterDiv.innerHTML =
        summaryRegisterDiv.innerHTML +
        '<div class="summary__desc">' +
        resolvedCheckbox.name +
        '</div>' +
        '                        <div>' +
        resolvedCheckbox.count +
        '</div>' +
        '                        <div><strong>' +
        formatNumber(resolvedCheckbox.price) +
        ' Kč</strong></div>';
    });

    let totalWithoutVatPrice = (participantPrice + totalCheckboxPrice).toFixed(
      2
    );
    totalWithoutVatDiv.innerHTML = formatNumber(totalWithoutVatPrice) + ' Kč';
    totalWithVatDiv.innerHTML =
      formatNumber((totalWithoutVatPrice * (1 + dphPercent / 100)).toFixed(2)) + ' Kč';
    vatDiv.innerHTML =
      formatNumber(
        (totalWithoutVatPrice * (1 + dphPercent / 100) - totalWithoutVatPrice).toFixed(2)
      ) + ' Kč';
  }

  function formatNumber(x) {
    if (x || x === 0) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }
  }

  function watchUpdateCreatedUser() {
    let createdUsers = document.getElementsByClassName('created-email');
    createdUsers.forEach(function (createdUser) {
      createdUser.addEventListener('blur', (event) => {
        createdUserInputs = document.getElementsByClassName(
          event.currentTarget.dataset.employeeId
        );

        let createdTitleBeforeName = '';
        let createdFullName = '';
        let createdTitleAfterName = '';
        let createdEmail = '';
        let employeeId = '';
        createdUserInputs.forEach(function (createdUserInput) {
          let datasetInputType = createdUserInput.dataset.inputType;
          if (datasetInputType === 'title-before-name') {
            createdTitleBeforeName = createdUserInput.value;
          }
          if (datasetInputType === 'full-name') {
            createdFullName = createdUserInput.value;
          }
          if (datasetInputType === 'title-after-name') {
            createdTitleAfterName = createdUserInput.value;
          }
          if (datasetInputType === 'email') {
            createdEmail = createdUserInput.value;
            employeeId = createdUserInput.dataset.employeeId;
          }
        });
        updateCreatedUser(
          createdTitleBeforeName,
          createdFullName,
          createdTitleAfterName,
          createdEmail,
          employeeId
        );
      });
    });
  }

  function updateCreatedUser(
    titleBeforeName,
    fullName,
    titleAfterName,
    email,
    employeeId
  ) {
    $.ajax({
      type: 'POST',
      url: '/api/executor/update-outside-participant',
      data: {
        temporaryRegistrationId: temporaryRegistrationId,
        employeeId: employeeId,
        participantTitleBeforeName: titleBeforeName,
        participantName: fullName,
        participantTitleAfterName: titleAfterName,
        participantEmail: email,
      },
      success: function () {},
    });
  }
}
